import DataGrid, {
	ColumnChooser,
	ColumnFixing,
	FilterRow,
	HeaderFilter,
	Item,
	LoadPanel,
	Paging,
	Scrolling,
	StateStoring,
	Toolbar,
	IDataGridOptions,
	Search
} from 'devextreme-react/data-grid';

import React, { useCallback, useRef } from 'react';
import { ColumnChooserButton, ExportToExcelButton, ExportToPdfButton } from '..';
import { useScreenSize } from '../../utils/media-query';

interface SyncDataGridProps extends React.PropsWithChildren<IDataGridOptions> {
	stateStorageKey?: string,
	hideExportToExcelButton?: boolean,
	hidePrintButton?: boolean,
	hideChooseColumnsButton?: boolean,
	additionalToolbarItems?: Array<React.ReactNode>
}

export default function SyncDataGrid(props: SyncDataGridProps) {

	const dataGridRef = useRef<DataGrid>(null);
	const screenSize = useScreenSize();
	const isSmallScreen = screenSize.isTiny || screenSize.isXSmall || screenSize.isSmall;

	const gridStateCustomSave = useCallback((state: any) => {
		if (!!props.stateStorageKey && state.columns) {
			for (var column of state.columns) {

				// Do not store filters in state
				delete column['filterValue'];
				delete column['filterValues'];
				delete column['filterType'];
			}
			localStorage.setItem(props.stateStorageKey, JSON.stringify(state));
		}
	}, [props.stateStorageKey]);

	const gridStateCustomLoad = useCallback(() => {
		if (!!props.stateStorageKey) {
			const s = localStorage.getItem(props.stateStorageKey);
			return s ? JSON.parse(s) : {};
		}
	}, [props.stateStorageKey]);

	return (
		<>
			<DataGrid
				ref={dataGridRef}
				allowColumnReordering={true}
				allowColumnResizing={true}
				showBorders={true}
				showColumnLines={true}
				columnAutoWidth={true}
				wordWrapEnabled={isSmallScreen}
				height="68vh"
				{...props}
			>
				<StateStoring
					enabled={!!props.stateStorageKey}
					type="custom"
					storageKey={props.stateStorageKey}
					customSave={gridStateCustomSave}
					customLoad={gridStateCustomLoad}
					savingTimeout={0}
				/>

				<ColumnChooser enabled={!isSmallScreen} />
				<Paging enabled={false}></Paging>
				<Scrolling rowRenderingMode='virtual'></Scrolling>
				<ColumnFixing enabled={true} />
				<LoadPanel enabled={false} />
				<HeaderFilter visible={true} >
					<Search enabled={true} />
				</HeaderFilter>
				<FilterRow visible={true} />

				<Toolbar visible={(props.additionalToolbarItems?.length ?? 0) > 0 ||
					(!isSmallScreen &&
						(!props.hideExportToExcelButton || !props.hidePrintButton || !props.hideChooseColumnsButton))}>

					{props.additionalToolbarItems}

					<Item location='after' visible={!props.hideExportToExcelButton && !isSmallScreen}>
						<ExportToExcelButton dataGrid={dataGridRef.current?.instance!} />
					</Item>
					<Item location='after' visible={!props.hidePrintButton && !isSmallScreen}>
						<ExportToPdfButton dataGrid={dataGridRef.current?.instance!} />
					</Item>
					<Item location='after' visible={!props.hideChooseColumnsButton && !isSmallScreen}>
						<ColumnChooserButton dataGrid={dataGridRef.current?.instance!} />
					</Item>
				</Toolbar>

				{props.children}

			</DataGrid>
		</>
	)
} 
